<template>
  <div class="row">
    <div class="col-12">
      <div class="new-button-div">
        <n-button
          @click.native="openItemAdd()"
          type="primary"
          round
          v-if="permisosComunicados.crear"
        >
          <i slot="label" class="now-ui-icons ui-1_simple-add"></i>
          {{ $t("app.buttons.new") }}
        </n-button>
      </div>
      <card
        v-if="permisosComunicados.acceder"
        card-body-classes="table-full-width"
        no-footer-line
      >
        <div
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <h4 class="card-title text-purple">
            {{ $t("app.modules.messages.title") }}
          </h4>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-lg-2 col-md-3 col-sm-6">
              {{ $t("app.modules.messages.headers.type") }}
              <el-select
                class="select-danger"
                v-model="typeSelected"
                filterable
                :placeholder="$t('app.modules.orders.headers.type')"
              >
                <el-option :label="$t('app.general.all')" value="0"></el-option>
                <el-option
                  :label="$t('app.modules.messages.types.promo')"
                  value="1"
                ></el-option>
                <el-option
                  :label="$t('app.modules.messages.types.advice')"
                  value="2"
                ></el-option>
                <el-option
                  :label="$t('app.modules.messages.types.bulletin')"
                  value="3"
                ></el-option>
              </el-select>
            </div>

            <div class="col-lg-2 col-md-3 col-sm-6">
              {{ $t("app.general.state") }}
              <el-select
                class="select-danger"
                v-model="statusSelected"
                filterable
                :placeholder="$t('app.modules.orders.headers.status')"
              >
                <el-option :label="$t('app.general.all')" value="0"></el-option>
                <el-option
                  :label="$t('app.general.active')"
                  :value="$t('app.general.active')"
                ></el-option>
                <el-option
                  :label="$t('app.general.inactive')"
                  :value="$t('app.general.inactive')"
                ></el-option>
              </el-select>
            </div>
            <div :class="sizes">
              {{ $t("app.modules.orders.filters.created_date_ini") }}

              <fg-input>
                <el-date-picker
                  type="date"
                  placeholder="Date Picker"
                  v-model="iniDate"
                >
                </el-date-picker>
              </fg-input>
            </div>

            <div :class="sizes">
              {{ $t("app.modules.orders.filters.created_date_end") }}

              <fg-input>
                <el-date-picker
                  type="date"
                  placeholder="Date Picker"
                  v-model="endDate"
                >
                </el-date-picker>
              </fg-input>
            </div>
            <div :class="sizes">
              {{ $t("app.modules.messages.headers.name") }}

              <fg-input>
                <el-input
                  type="search"
                  class="mb-2"
                  clearable
                  prefix-icon="el-icon-search "
                  style="width: 200px"
                  :placeholder="$t('app.general.search')"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </fg-input>
            </div>
          </div>
        </div>
        <div>
          <el-table stripe style="width: 100%;" :data="queriedData">
            <el-table-column
              :label="$t('app.modules.messages.headers.type')"
              min-width="120"
              sortable
            >
              <template slot-scope="scope">
                <span v-if="scope.row.idTipoComunicado == 1">
                  {{ $t("app.modules.messages.types.promo") }}
                </span>
                <span v-if="scope.row.idTipoComunicado == 2">
                  {{ $t("app.modules.messages.types.advice") }}
                </span>
                <span v-if="scope.row.idTipoComunicado == 3">
                  {{ $t("app.modules.messages.types.bulletin") }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('app.modules.messages.headers.create_date')"
              min-width="250"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.fechaRegistro }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('app.modules.messages.headers.name')"
              min-width="200"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.nombreComunicacion }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('app.modules.messages.headers.ini_date')"
              min-width="200"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.fechaInicio }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('app.modules.messages.headers.end_date')"
              min-width="200"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.fechaFin }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('app.modules.messages.headers.state')"
              min-width="120"
              fixed="right"
              className="is-center"
            >
              <template slot-scope="scope">
                {{
                  scope.row.activo
                    ? $t("app.general.active")
                    : $t("app.general.inactive")
                }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('app.general.active')"
              min-width="100"
              className="is-center"
            >
              <template slot-scope="props">
                <n-switch
                  :disabled="!permisosComunicados.editar"
                  :ref="'switch-' + props.$index"
                  v-model="props.row.activo"
                  @input="activeMessage(props.row, 'switch-' + props.$index)"
                  color="black"
                >
                  <i class="now-ui-icons ui-1_check" slot="on"></i>
                  <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                </n-switch>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="100"
              fixed="right"
              className="is-center"
            >
              <div slot-scope="props" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="250"
                  trigger="click"
                  :ref="'refOption' + props.$index"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        v-if="permisosComunicados.editar"
                        @click.native="
                          EditMessage(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.messages.edit.title") }}
                      </n-button>
                      <n-button
                        @click.native="
                          DetailsMessage(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.messages.details.title") }}
                      </n-button>
                    </div>
                  </div>
                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    class="button-options-table"
                  >
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>
                </el-popover>
              </div>
            </el-table-column>
          </el-table>
        </div>

        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }}
              {{ $t("app.pagination.of") }} {{ to }}
              {{ $t("app.pagination.of") }} {{ total }}
              {{ $t("app.pagination.records") }}
            </p>
          </div>

          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </n-pagination>
        </div>
      </card>

      <comunicados-add />
      <comunicados-edit />
      <comunicados-details />
    </div>
  </div>
</template>

<script>
import Fuse from "fuse.js";
import { mapState } from "vuex";
export default {
  components: {
    ComunicadosAdd: () => import("./comunicadosAdd"),
    ComunicadosEdit: () => import("./comunicadosEdit"),
    ComunicadosDetails: () => import("./comunicadosDetails")
  },
  computed: {
    ...mapState(["modules"]),
    queriedData() {
      let result = this.tableData;

      // filter by search term
      result =
        this.searchQuery.length > 0
          ? result.filter(p =>
              p.nombreComunicacion
                .toLowerCase()
                .includes(this.searchQuery.toLowerCase())
            )
          : result;

      // filter by type
      result =
        this.typeSelected > 0
          ? result.filter(d => d.idTipoComunicado == this.typeSelected)
          : result;

      // filter by status
      result =
        this.statusSelected == this.$t("app.general.active")
          ? result.filter(d => d.activo == true)
          : result;
      result =
        this.statusSelected == this.$t("app.general.inactive")
          ? result.filter(d => d.activo == false)
          : result;

      // filter by date
      result =
        this.iniDate > new Date("1900-01-01") &&
        this.endDate > new Date("1900-01-01") &&
        this.iniDate instanceof Date &&
        this.endDate instanceof Date
          ? (result = result.filter(
              d =>
                new Date(d.fechaRegistro) >= this.iniDate &&
                new Date(d.fechaRegistro) <= this.endDate
            ))
          : result;

      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      permisosComunicados: {
        acceder: false,
        crear: false,
        editar: false
      },
      sizes: "col-lg-2 col-md-3 col-sm-6",
      typeSelected: "Todos",
      statusSelected: "",
      iniDate: new Date("2020-01-01"),
      endDate: new Date("2020-12-31"),
      createDate: new Date(2020, 1, 1),
      datePickerModal: false,
      searchQuery: "",
      searchedData: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      tableData: []
    };
  },
  async created() {
    await this.PermisosComunicados();
  },
  async mounted() {
    console.log(this.$root.$i18n.locale);
    EventBus.$on("reload-promos", () => {
      this.init();
    });
  },
  methods: {
    async PermisosComunicados() {
      var permisos = [];
      for (var i = 0; i < this.modules.length; i++) {
        if (
          this.modules[i].nombreModulo === "Promociones, avisos y boletines"
        ) {
          permisos = this.modules[i].claimsModule;
          break;
        }
      }
      for (var con = 0; con < permisos.length; con++) {
        console.log(permisos[con].active);
        if (permisos[con].permiso == "Acceder" && permisos[con].active) {
          this.permisosComunicados.acceder = true;
        }
        if (permisos[con].permiso == "Crear" && permisos[con].active) {
          this.permisosComunicados.crear = true;
        }
        if (permisos[con].permiso == "Editar" && permisos[con].active) {
          this.permisosComunicados.editar = true;
        }
      }
      await this.verificarEntrada();
    },
    async verificarEntrada() {
      if (this.permisosComunicados.acceder) {
        this.init();
      } else {
        this.$alert(this.$t("app.promps.permission_error"), "", {
          confirmButtonText: this.$t("app.buttons.accept"),
          callback: action => {
            console.log("Ventana cerrada");
            this.$router.push({
              name: "Home"
            });
          }
        });
      }
    },
    async init() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.getItems();
      this.$swal.close();
    },
    async getItems() {
      const params = {
        Id: 0,
        ClaveIdioma: this.$store.state.lang
      };

      await this.$http
        .post(route("Comunicaciones/getComunicaciones"), params)
        .then(
          response => {
            if (response.body.code === 200) {
              this.tableData = response.body.comunicaciones;
            } else {
              console.log(response.body);
              // this.processError(response.body)
            }
          },
          error => {
            console.error(error);
            // this.processError(error)
          }
        );
    },
    async activeMessage(row, ref) {
      this.$confirm(this.$t("app.modules.messages.alert.title"), "", {
        confirmButtonText: this.$t("app.modules.messages.alert.yes"),
        cancelButtonText: this.$t("app.modules.messages.alert.cancel"),
        //type: "warning",
        center: true
      })
        .then(async () => {
          //Enviar
          const params = {
            Id: 0,
            ClaveIdioma: this.$store.lang,
            Usuario: this.$store.Id,
            Comunicacion: row
          };
          await this.$http
            .put(route("Comunicaciones/updateComunicado"), params)
            .then(
              async response => {
                if (response.body.code === 200) {
                  console.log(response.body);
                  this.notifyMessage(
                    "success",
                    this.$t("app.promps.save_success")
                  );
                  this.init();
                } else {
                  this.notifyMessage("danger", this.$t("app.promps.error"));
                }
              },
              error => {
                this.notifyMessage("danger", this.$t("app.promps.error"));
              }
            )
            .finally(() => {});
        })
        .catch(() => {
          row.activo = !row.activo;
        });
    },
    openItemAdd() {
      EventBus.$emit("comunicados-add");
    },
    EditMessage(index, row, ref) {
      this.$refs[ref].doClose();
      EventBus.$emit("comunicados-edit", row);
    },
    DetailsMessage(index, row, ref) {
      this.$refs[ref].doClose();
      EventBus.$emit("comunicados-details", row);
    }
  }
};
</script>
